import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private renderer: Renderer2, private router: Router) {}

  ngOnInit(): void {
    const savedTheme = localStorage.getItem('tubify-theme') || 'light';
    this.renderer.setAttribute(document.documentElement, 'data-theme', savedTheme);
    console.log('[Tubify] App initialized, current route:', this.router.url);
  }

  onActivate(evt: unknown): void {
    console.log('[Tubify] Activated component:', evt);
  }

  private forceInitialRoute(): void {
    const current = this.router.url;
    const needsRedirect = !current || current === '/' || current === '';
    if (needsRedirect) {
      setTimeout(() => this.router.navigate(['/landing']), 0);
    }
  }
}
